// extracted by mini-css-extract-plugin
export var required = "_fj-0";